module.exports = __webpack_public_path__ + "img/curved.3d1cc1e8.png";